import React, {useEffect, useState, ChangeEvent, FormEvent} from 'react';
import './community.css';

interface FormData {
	name: string;
	email: string;
	updates: boolean;
}

const Community: React.FC = () => {
	const [formData, setFormData] = useState<FormData>({
		name: '',
		email: '',
		updates: false
	});

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const {name, value, type, checked} = e.target;
		setFormData(prev => ({
			...prev,
			[name]:type === "checkbox" ? checked : value
		}));

		// Floating label effect
		const label = e.target.nextElementSibling;
		if (label instanceof HTMLElement) {
			if (value) {
				label.classList.add('active');
			} else {
				label.classList.remove('active');
			}
		}
	};

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();
		// TODO: handle form submission
	};

	return (
		<div className='community-wrapper'>
			<span className='community-span'>Join Our Community To Learn More</span>
			<form className='community-form' onSubmit={handleSubmit}>
				<div className='form-group'>
					<input 
						type="text"
						id='name'
						name='name'
						value={formData.name}
						onChange={handleChange}
						required
					/>
					<label htmlFor="name">Name</label>
				</div>
				<div className='form-group'>
					<input 
						type="text" 
						id='email'
						name='email'
						value={formData.email}
						onChange={handleChange}
						required
					/>
					<label htmlFor="email">Email</label>
				</div>
				<div className='form-checkbox'>
					<input 
						type="checkbox" 
						id="updates"
						name="updates"
						checked={formData.updates}
						onChange={handleChange}
					/>
					<label htmlFor="updates">Receive research updates</label>
				</div>
				<div className="form-footer">
					<span className="acknowledge promise">We value your privacy and never share data.</span>
					<button type='submit' className="submit-btn">Join Community</button>
				</div>
			</form>
		</div>
	)
}

export default Community;

// TODO
// Handle submitted data.
